/**
 * Arktis Gratis-Geschenk – Cart-Sync
 *
 * Hält den Cart konsistent zur Regel "1 Gratis-Geschenk, sobald ein anderes Produkt im Cart liegt":
 *  - legt das Geschenk (Menge 1, Property _geschenk) automatisch dazu
 *  - entfernt es, wenn sonst nichts mehr im Cart ist oder die Aktion (Tag "Geschenk") aus ist
 *  - setzt manipulierte Mengen zurück auf 1 und entfernt doppelte Geschenk-Positionen
 *  - entfernt regulär hinzugefügte Geschenk-Produkte, falls "separat kaufbar" im App-Backend aus ist
 *
 * Der Preis wird NICHT hier, sondern serverseitig von der Shopify Function genullt.
 */
(function () {
  const config = window.ArktisGeschenk;
  if (!config || !config.variantId) return;

  const GIFT_PROPERTY = '_geschenk';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  let running = false;
  let queued = false;

  const isGift = (item) => Boolean(item.properties && item.properties[GIFT_PROPERTY]);

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) throw new Error('Geschenk: ' + path + ' -> ' + response.status);
      return response.json();
    });
  }

  async function reconcile() {
    const cart = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const gifts = cart.items.filter(isGift);
    // Nur relevant, wenn "Produkt kann zusätzlich separat gekauft werden" aus ist
    const blocked = cart.items.filter(
      (item) => !isGift(item) && config.active && !config.allowSeparatePurchase && item.product_id === config.productId
    );
    const hasRegular = cart.items.length > gifts.length + blocked.length;
    const wanted = config.active && hasRegular;

    if (!wanted || blocked.length) {
      const updates = {};
      blocked.forEach((item) => (updates[item.key] = 0));
      if (!wanted) gifts.forEach((item) => (updates[item.key] = 0));
      if (Object.keys(updates).length) {
        await post('cart/update.js', { updates });
        return true;
      }
      if (!wanted) return false;
    }

    if (!gifts.length) {
      await post('cart/add.js', {
        items: [
          {
            id: config.variantId,
            quantity: 1,
            properties: { [GIFT_PROPERTY]: '1', _warenwert: config.warenwert },
          },
        ],
      });
      return true;
    }

    // Genau eine Geschenk-Position mit Menge 1 behalten
    const updates = {};
    gifts.forEach((item, index) => {
      const target = index === 0 ? 1 : 0;
      if (item.quantity !== target) updates[item.key] = target;
    });
    if (!Object.keys(updates).length) return false;
    await post('cart/update.js', { updates });
    return true;
  }

  async function refreshUI() {
    if (config.isCartPage) {
      window.location.reload();
      return;
    }
    const drawer = document.querySelector('cart-drawer');
    const sections = await nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble').then((r) => r.json());
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      bubble.innerHTML = parse(sections['cart-icon-bubble']).querySelector('.shopify-section').innerHTML;
    }

    if (drawer && sections['cart-drawer']) {
      const fresh = parse(sections['cart-drawer']);
      const freshDrawer = fresh.querySelector('cart-drawer');
      const target = drawer.querySelector('#CartDrawer');
      const source = fresh.querySelector('#CartDrawer');
      if (target && source) {
        target.innerHTML = source.innerHTML;
        if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        // Das Theme blendet Drawer-Inhalte erst in open() ein ([data-aos] -> .aos-animate).
        // Ist der Drawer schon offen, müssen die frisch gerenderten Elemente das nachholen.
        if (drawer.classList.contains('active')) {
          target.querySelectorAll('[data-aos]').forEach((element) => element.classList.add('aos-animate'));
        }
      }
    }
  }

  async function sync() {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    try {
      if (await reconcile()) await refreshUI();
    } catch (error) {
      console.error(error);
    } finally {
      running = false;
      if (queued) {
        queued = false;
        sync();
      }
    }
  }

  // Jede Cart-Mutation (Theme, GemPages, Abo-App …) abfangen – unabhängig vom Auslöser.
  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = nativeFetch(input, init);
    if (CART_MUTATION.test(url)) result.then(() => setTimeout(sync, 0)).catch(() => {});
    return result;
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) this.addEventListener('load', () => setTimeout(sync, 0));
    return nativeOpen.apply(this, arguments);
  };

  window.addEventListener('pageshow', sync);
})();
